import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(() => ({
  filtersGrid: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
    // marginRight: spacing(3)
  }
}))
